export type TPlural = [string, string, string];

export const flat: TPlural = ['похожая квартира', 'похожие квартиры', 'похожих квартир'];
export const suburban: TPlural = ['похожий объект', 'похожих объекта', 'похожих объектов'];
